export default __webpack_public_path__ + "static/media/18-lead.16cd9c29.png";